(function() { module.exports = this["ReactDOM"]; }());


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 5
// module chunks = 0